export default __webpack_public_path__ + "static/media/searchDude.1eb45c9f.svg";